import { ABaseService } from '@/libs/service'

import { StaffStatus } from '../models/staff.model'
import IStaffService from './staff.interface'

export default class StaffService
  extends ABaseService
  implements IStaffService
{
  async updateStatus(staffId: string, status: StaffStatus): Promise<boolean> {
    if (!staffId) {
      return false
    }
    const { hasError, error } = await this.clientHttp.put(
      `staff/${staffId}/updateStatus`,
      {
        status
      }
    )

    if (hasError) {
      this.setError({
        message: 'Ocorreu um erro ao alterar seu status status',
        error,
        request: 'staff/updateStatus'
      })
      return false
    }
    return true
  }
}
